import { create } from "zustand";
import { zs_Global } from "./zs_Global";
import { zsHostSignup } from "./zsHostSignup";
import { zsHome } from "./zsHome";
export const useZustandStore = create((set) => ({
  ...zs_Global(set),
  ...zsHostSignup(set),
  ...zsHome(set),
}));
